export default __webpack_public_path__ + "static/DSC_0084-9fabb88767c4270eee4241c23c081cd3.jpg";